import { createFileRoute } from '@tanstack/react-router'
import {
  Dropdown,
  DropdownButton,
  DropdownItems,
  DropdownItem,
} from '../../../../components/Dropdown'

export const Route = createFileRoute('/_authenticated/settings/lab/')({
  component: RouteComponent,
})

function RouteComponent() {
  const onItemClick = (value: string | undefined) => {
    alert('Item clicked: ' + value)
  }

  return (
    <div>
      <h1>Lab Settings</h1>
      <div className="py-4">
        <Dropdown>
          <DropdownButton>Dropdown</DropdownButton>
          <DropdownItems>
            <DropdownItem value="item1" onClick={onItemClick}>
              Item 1
            </DropdownItem>
            <DropdownItem value="item2" onClick={onItemClick}>
              Item 2
            </DropdownItem>
            <DropdownItem value="item3" onClick={onItemClick}>
              Item 3
            </DropdownItem>
          </DropdownItems>
        </Dropdown>
      </div>
    </div>
  )
}
